import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDateBR, whatsappLink } from "@/lib/format";
import { MessageCircle, Cake } from "lucide-react";

const RANGES = [
  { id: "today", label: "Hoje" },
  { id: "week", label: "Esta semana" },
  { id: "month", label: "Este mês" },
];

export default function Aniversarios() {
  const { studio } = useAuth();
  const [range, setRange] = useState("month");
  const [items, setItems] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const [r, t] = await Promise.all([
        api.get("/clients/birthdays/list", { params: { range } }),
        api.get("/message-templates"),
      ]);
      setItems(r.data); setTemplates(t.data);
      setLoading(false);
    })();
  }, [range]);

  const bdayTemplate = templates.find(t => t.category === "aniversario");
  const buildMessage = (c) => {
    let msg = bdayTemplate?.content || `Feliz aniversário, {nome}! Muitas felicidades!`;
    return msg.replaceAll("{nome}", c.name).replaceAll("{studio}", studio?.name || "");
  };

  return (
    <div className="space-y-4" data-testid="birthdays-page">
      <div>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-[#27272A]">Aniversários</h1>
        <p className="text-[#71717A] text-sm mt-1">Envie uma mensagem carinhosa no dia certo.</p>
      </div>

      <div className="flex gap-2 overflow-x-auto hide-scrollbar" data-testid="range-filter">
        {RANGES.map(r => (
          <button key={r.id} onClick={() => setRange(r.id)} data-testid={`range-${r.id}`}
            className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold ${range === r.id ? "bg-[#682F3E] text-white" : "bg-white text-[#71717A] border border-[#E4E4E7]"}`}>
            {r.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-[#71717A] text-sm">Carregando…</div>
      ) : items.length === 0 ? (
        <div className="card-nc p-8 text-center" data-testid="birthdays-empty">
          <p className="text-[#71717A]">Nenhum aniversário {range === "today" ? "hoje" : range === "week" ? "esta semana" : "este mês"}.</p>
        </div>
      ) : (
        <div className="grid gap-2">
          {items.map(c => (
            <div key={c.id} data-testid={`bday-${c.id}`} className="card-nc p-4 flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-[#F5ECE8] flex items-center justify-center text-[#682F3E]">
                <Cake size={20} />
              </div>
              <div className="flex-1">
                <div className="font-semibold text-[#27272A]">{c.name}</div>
                <div className="text-xs text-[#71717A]">
                  {fmtDateBR(c.birthdate)}
                  {c.days_until === 0 && <span className="ml-2 badge-status bg-[#EBF2EE] text-[#4F7A61]">Hoje!</span>}
                  {c.days_until > 0 && c.days_until <= 7 && <span className="ml-2 badge-status bg-[#F5ECE8] text-[#682F3E]">em {c.days_until}d</span>}
                </div>
              </div>
              {(c.whatsapp || c.phone) && (
                <a href={whatsappLink(c.whatsapp || c.phone, buildMessage(c))} target="_blank" rel="noreferrer"
                  data-testid={`wa-bday-${c.id}`}
                  className="btn-primary-nc py-2 px-3 text-xs flex items-center gap-1">
                  <MessageCircle size={14} /> Parabenizar
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
